import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import listPlugin from '@fullcalendar/list' // Import the list plugin
import interactionPlugin from '@fullcalendar/interaction'
import dayjs from 'dayjs'

import { useEffect, useRef, useState } from 'react'
import { CalendarEventViewModal } from '@forwardflow/modals'
import { useCalendarEventViewModalStore } from '@forwardflow/store/modal'

interface FullCalendarContainerProps {
   selectedDate?: string | Date
}

export const FullCalendarContainer: React.FC<FullCalendarContainerProps> = ({
   selectedDate,
}) => {
   const calendarRef = useRef<any>({})
   const [selectedEvent, setSelectedEvent] = useState<any>(null)
   const { openCalendarViewModal } = useCalendarEventViewModalStore()

   const handleEventClick = (clickInfo: any) => {
      setSelectedEvent(clickInfo.event)
      openCalendarViewModal()
   }
   useEffect(() => {
      const calendarApi = calendarRef.current.getApi()
      calendarApi.gotoDate(dayjs(selectedDate).format('YYYY-MM-DD'))
   }, [selectedDate])
   const [events] = useState([
      {
         client: 'David James',
         agent: 'John Doe',
         start: dayjs().hour(10).minute(0).toISOString(),
         end: dayjs().hour(11).minute(0).toISOString(),
         backgroundColor: 'rgba(61, 36, 62, 1)',
         borderColor: '#B98BE6',
      },
      {
         client: 'David James',
         agent: 'John Doe',
         start: dayjs().hour(10).minute(10).toISOString(),
         end: dayjs().hour(11).minute(0).toISOString(),
         backgroundColor: 'rgba(61, 36, 62, 1)',
         borderColor: '#B98BE6',
      },

      {
         client: 'David James',
         agent: 'John Doe',
         start: dayjs().add(1, 'day').hour(14).minute(0).toISOString(),
         end: dayjs().add(1, 'day').hour(15).minute(0).toISOString(),
         backgroundColor: 'rgba(39, 58, 57, 1)',
         borderColor: '#B98BE6',
      },
   ])
   return (
      <div className="flex-1 h-[calc(100vh-110px)] p-4 rounded-lg bg-primary/10">
         <FullCalendar
            plugins={[
               dayGridPlugin,
               timeGridPlugin,
               listPlugin,
               interactionPlugin,
            ]} // Add listPlugin here
            initialView="timeGridWeek" // Start with the week view
            headerToolbar={{
               left: 'prev,next today',
               center: 'title',
               right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek', // Add listWeek view
            }}
            // initialDate={
            //    selectedDate
            //       ? dayjs(selectedDate).format("YYYY-MM-DD")
            //       : dayjs().format("YYYY-MM-DD")
            // }
            ref={calendarRef}
            events={events}
            editable={false}
            selectable={false}
            nowIndicator={true}
            slotDuration="00:10:00" // Sets 30-minute intervals
            slotMinTime="06:00:00" // Start time of the day
            slotMaxTime="24:00:00" // End time of the day
            height="100%"
            dayMaxEvents={3}
            eventClick={handleEventClick}
            eventContent={(eventInfo) => {
               if (eventInfo.view.type === 'dayGridMonth') {
                  return (
                     <div className="w-full p-1">
                        <div className="flex items-center w-full overflow-hidden text-xs text-ellipsis">
                           <span
                              style={{
                                 backgroundColor: eventInfo.event.borderColor,
                              }}
                              className={`w-[10px] h-[10px] inline-block rounded-full mr-2`}
                           ></span>
                           <span className="mr-2">
                              {dayjs(eventInfo.event.start).format('h:mm a')}
                           </span>

                           <span className="font-medium">
                              {eventInfo.event.extendedProps.client}
                           </span>
                        </div>
                     </div>
                  )
               }
               if (eventInfo.view.type === 'listWeek') {
                  return (
                     <>
                        <div className="w-full p-1">
                           <div className="flex items-center w-full overflow-hidden text-xs text-ellipsis">
                              <span className="font-medium">
                                 {eventInfo.event.extendedProps.client} with{' '}
                                 {eventInfo.event.extendedProps.agent}
                              </span>
                           </div>
                        </div>
                     </>
                  )
               }

               return (
                  <div className="w-full p-1">
                     <div className="w-full overflow-hidden text-sm text-ellipsis whitespace-nowrap">
                        {dayjs(eventInfo.event.start).format('h:mm a')} -{' '}
                        {dayjs(eventInfo.event.end).format('h:mm a')}
                     </div>
                     <div className="w-full overflow-hidden text-sm font-bold text-ellipsis whitespace-nowrap">
                        {eventInfo.event.extendedProps.client}
                     </div>
                     <div className="w-full overflow-hidden text-sm text-ellipsis whitespace-nowrap">
                        {eventInfo.event.extendedProps.agent}
                     </div>
                  </div>
               )
            }}
         />
         <CalendarEventViewModal selectedEvent={selectedEvent} />
      </div>
   )
}
